import { useMemo } from "react";
import { ListFormatter, TextFormatter } from "../muiTableHelper";
import { IconButton } from "@mui/material";
import { createConfirm } from "../../confirm";
import { RequestHelper } from "../../requestHelper";
import { _ACTIONS, _SWAL_ICONS } from "../../constants";
import { _ROUTES } from "../../_routes_constants";
import { createToast } from "../../toast";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

export const CompaniesListColumns = ({
  setEditData,
  setShowModal,
  setRefresh,
}) => {
  return useMemo(
    () => [
      {
        accessorKey: "name",
        header: "Name",
        Cell: ({ row }) => {
          return TextFormatter({
            text: row.original.name,
          });
        },
      },
      {
        accessorKey: "code",
        header: "Code",
        Cell: ({ row }) => {
          return TextFormatter({
            text: row.original.code,
          });
        },
      },
      {
        accessorKey: "sites",
        header: "Sites",
        Cell: ({ row }) => {
          return ListFormatter(row.original.sites, "name");
        },
      },
      {
        accessorKey: "actions",
        header: "Actions",
        Cell: ({ row }) => {
          return (
            <>
              <IconButton
                variant="contained"
                color="primary"
                onClick={() => {
                  setEditData(row.original);
                  setShowModal(true);
                }}>
                <EditIcon />
              </IconButton>
              <IconButton
                variant="contained"
                color="secondary"
                onClick={() => {
                  createConfirm("Are you sure you want to delete this company?")
                    .fire({})
                    .then((result) => {
                      if (result.isConfirmed) {
                        // Processing
                        const rq = new RequestHelper();

                        rq.doRequest(
                          _ACTIONS.DELETE,
                          _ROUTES.COMPANIES + "/" + row.original.id
                        ).then((res) => {
                          if (res.status === 204) {
                            createToast(
                              _SWAL_ICONS.success,
                              "The company has been deleted"
                            ).then(() => {
                              setRefresh((prev) => prev++);
                            });
                          } else {
                            createToast(_SWAL_ICONS.error, res.message);
                          }
                        });
                      }
                    });
                }}>
                <DeleteForeverIcon />
              </IconButton>
            </>
          );
        },
      },
    ],
    [setEditData, setShowModal, setRefresh]
  );
};
